export default "__VITE_ASSET__BCEVBXxz__"